import React, { useState } from 'react';
import SignatureModal from '../components/SignatureModal';
import BackdropModal from '../components/modals/backdrop_modal';

const Signature = () => {
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <div>
      <button onClick={openModal}>Open Signature Pad</button>
          <BackdropModal size={"xl"} open={isModalOpen} modalTitle="Uploaded Documents">
              <SignatureModal isOpen={isModalOpen} onClose={closeModal} />
          </BackdropModal>
    </div>
  );
};

export default Signature;
